import { Directive, Inject, Input, NgModule, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ScrollToConfigOptions, ScrollToService } from '@nicky-lenaers/ngx-scroll-to';
import { WINDOW } from '@wizbii/angular-utilities';

@Directive({
  selector: '[appScrollToFragment]',
})
export class ScrollToFragmentDirective implements OnInit {
  @Input() prefix?: string;
  @Input() offset?: number = -300;

  constructor(
    @Inject(WINDOW) private readonly window: any,
    private readonly scrollToService: ScrollToService,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    if (this.route.snapshot.fragment) {
      this.scrollToFragment(this.route.snapshot.fragment);
    }
  }

  private scrollToFragment(fragment: string): void {
    const config: ScrollToConfigOptions = {
      target: this.prefix ? `${this.prefix}-${fragment}` : `${fragment}`,
      offset: this.offset,
    };

    this.window.setTimeout(() => {
      this.scrollToService.scrollTo(config);
    }, 100);
  }
}

@NgModule({
  declarations: [ScrollToFragmentDirective],
  exports: [ScrollToFragmentDirective],
})
export class ScrollToFragmentDirectiveModule {}
